import { Box, BoxProps, Flex, Heading, mdBumps, smBumps } from '@wrisk/ui-components'
import React from 'react'

import { getMandatoryExcessComparison, Quote } from '../../../domain'
import { useExcesses } from '../../../hooks/excess'
import {
  tExcesses,
  TKey,
  useWriskTranslation,
} from '../../../infrastructure/internationalisation'
import { ExcessRow } from './ExcessRow'

export interface OtherExcessProps extends BoxProps {
  currentQuote: Quote
  previousQuote?: Quote
}

const tKey = TKey('components.other-excesses')

export const OtherExcesses: React.FC<OtherExcessProps> = ({
  currentQuote,
  previousQuote,
  ...props
}) => {
  const { t } = useWriskTranslation()

  const { other: currentExcesses } = useExcesses(currentQuote)
  const { other: previousExcesses } = useExcesses(previousQuote)

  const excessComparisons = getMandatoryExcessComparison(
    previousExcesses,
    currentExcesses,
  )

  return excessComparisons.length ? (
    <Box width={1} {...props}>
      <Box mb={smBumps}>
        <Heading typoSize='md'>{t(tKey('header'))}</Heading>
      </Box>
      <Flex
        variant='raised'
        flexDirection='column'
        width={1}
        px={mdBumps}
        py={5}
        rowGap={mdBumps}
      >
        {excessComparisons.map((it, index) => (
          <ExcessRow
            key={`${it.category}-${index}`}
            header={t(tExcesses(it.category, 'name'))}
            currentExcess={it.current}
            previousExcess={it.previous}
          />
        ))}
      </Flex>
    </Box>
  ) : null
}
